const SDK_VERSION = '7.69.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
